// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { Component } from "react";

import { PageHeader, PageContent } from "components/layout";
import { trans } from "src/translations";

import { PromotionsTypesTableData } from "./PromotionsTypesTableData";

export class PromotionTypesTablePage extends Component {
  render() {
    return (
      <div>
        <PageHeader>{trans.PROMOTION_TYPE_LIST__PAGE_HEADER()}</PageHeader>
        <PageContent>
          <PromotionsTypesTableData />
        </PageContent>
      </div>
    );
  }
}
